import React, { useState, useEffect } from "react";
import { routes } from "../../router/paths";
import { Logo, Title } from "../../components/atoms";
// import { LoginForm } from "../../components/organisms";
import Actions from "../../store/actions/index";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useNavigate } from "react-router-dom";
import { AnalyticsService } from "../../utils/Analytics";
import { ChangePasswordForm } from "../../components/organisms/ChangePasswordForm/changePasswordForm";

const ChangePassword = (props) => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [isSubmit, setIsSubmit] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [isNewPassVisible, setIsNewPassVisible] = useState(true);
  const [isConfirmNewPassVisible, setIsConfirmNewPassVisible] = useState(true);

  useEffect(() => {
    const userEmail = localStorage.getItem("userEmail");
    setEmail(userEmail);

    localStorage.setItem("isAuthenticated", "false");
   
  }, []);

  const onChangeEmail = (e) => {
    setEmail(e.target.value);
  };

  const onChangePassword = (e) => {
    setPassword(e.target.value);
    if (password === "" && isSubmit === true) {     
      LoginPortal();
    }
  };
  const onChangeNewPassword = (e) => {
    setNewPassword(e.target.value);
  };
  const onChangeConfirmNewPassword = (e) => {
    
    
      setConfirmNewPassword(e.target.value);
    
  };

  const togglePassword = () => {
    setIsVisible(!isVisible);
  };

  const toggleNewPassword = () => {
      setIsNewPassVisible(!isNewPassVisible);
  };
  const toggleConfirmNewPassword = () => {
    setIsConfirmNewPassVisible(!isConfirmNewPassVisible);
};
  const validateEmail = (emailAddress) => {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(emailAddress)) {
      return true;
    }
    return false;
  };

  const LoginPortal = async (e) => {
    e.preventDefault();
    setIsSubmit(true);
    const { actions } = props;
    if (email !== "" && password !== "") {
      const response = await actions.changePassword({
        Email: email,
        Password: password,
        newPassword : newPassword,
        confirmNewPassword : confirmNewPassword,
      });
      if (response && response.success === true) {
        alert("Password reset successful");
        
        navigate(routes.dashboard);
        localStorage.setItem("isAuthenticated", true);
        navigate(0);
        setLoading(true);
      } else {
        setError(
          response && response.message
            ? response.message
            : "Internal server error"
        );
        setLoading(false);
        AnalyticsService.logEvent("USER_LOG_IN_ERROR", {
          Error:
            response && response.message
              ? response.message
              : "Internal server error",
        });
      }
    } else {
      setError("");
    }
  };

  return (
    <div className="flexPanel">
      <div className="leftPanel">
        <Logo />
        <Title text="The Cricket Store" className={"titleDefaultCls"} />
        <Title text="Merchant's Portal" className="subTitleCls" />
      </div>
      <div className="rightPanel">
        <div className="form-container">
          <Title text="Change Password" className={"titleDefaultCls"} />
          <Title text="" className={"titleDefaultCls"} />
          <ChangePasswordForm
            LoginPortal={LoginPortal}
            onChangeEmail={onChangeEmail}
            onChangePassword={onChangePassword}
            onChangeConfirmPassword = {onChangeConfirmNewPassword}
            onChangeNewPassword={onChangeNewPassword}
            email={email}
            password={password}
            newPassword={ newPassword}
            confirmNewPassword={ confirmNewPassword}
            isSubmit={isSubmit}
            validateEmail={validateEmail}
            errorMessage={error}
            togglePassword={togglePassword}
            toggleNewPassword={toggleNewPassword}
            toggleConfirmNewPassword={toggleConfirmNewPassword}
            isVisible={isVisible}
            isNewPassVisible={isNewPassVisible}
            isConfirmNewPassVisible={isConfirmNewPassVisible}
            isLoading={loading}
          />
        </div>
      </div>
    </div>
  );
};

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch),
  };
}

export default connect(null, mapDispatchToProps)(ChangePassword);
